module.exports = __webpack_public_path__ + "img/大尺寸地砖.f44fe8f7.webp";